import { useState } from "react";
import { Flex, Button } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import { PageHeader } from "@/v2/components/layout";
import { NotificationSquareIcon } from "@/v2/assets/icons/NotificationSquare";
import { PageColors, ENavigate } from "@/components/sidebar/sidebar.types";
import { CreateNoticeDialog } from "./CreateNoticeDialog";

interface NoticesPageHeaderProps {
  onCreateNoticeSuccess: (noticeId: string) => void;
}

export function NoticesPageHeader({ onCreateNoticeSuccess }: NoticesPageHeaderProps) {
  const [createNoticeDialogOpen, setCreateNoticeDialogOpen] = useState(false);

  return (
    <>
      <PageHeader
        title="Notices"
        description="Create short, authoritative updates Quack can surface across the product."
        icon={
          <NotificationSquareIcon
            size={24}
            fill={PageColors[ENavigate.NOTICES] || "gray"}
          />
        }
        actions={
          <Flex gap="2" align="center">
            <Button
              highContrast
              color="gray"
              onClick={() => setCreateNoticeDialogOpen(true)}
            >
              <PlusIcon />
              Create Notice
            </Button>
          </Flex>
        }
      />

      <CreateNoticeDialog
        open={createNoticeDialogOpen}
        onOpenChange={setCreateNoticeDialogOpen}
        onSuccess={onCreateNoticeSuccess}
      />
    </>
  );
}
